import React,{useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import swal from 'sweetalert';
import { useAxios } from '../../../../../utils/Axios';
import PopUp from '../../../../../components/UIElements/PopUp'
import ErrorPopUp from '../../../../../components/UIElements/ErrorPopup'
import httpImg from '../../../../../assests/integrations/http.png';

function HTTPCard(props) {
    const axiosInstance = useAxios();
    
    // useEffect(()=>{
    //     console.log(props);
    // },[props])

    //code to delete HTTP 
    function deleteHTTP(e){
        e.preventDefault();
        swal({
			title: "Are you sure?",
			text: "HTTP Integration will be deleted",
			icon: "warning",
			buttons: true,
			dangerMode: true,
			className: "dangerSwal"
		})
			.then((willDelete) => {
				if (willDelete) {
					axiosInstance
						.delete(`${process.env.REACT_APP_LORA_URL}/applications/${props.applicationID}/integrations/http`)
						.then((response) => {
							PopUp("Success");
							props.status(true);
						})
						.catch((err) => {
							// console.log(err);
                            ErrorPopUp("Deleting Failed. Try Again");
                            // props.status(true);
						});
				}
			});
    }
    return (
        <Col md={4} lg={3} className="cardsCol">
            <Card style={{ width: '18rem' }}>
                <Card.Body>
                    <Card.Title>
                        <img src={httpImg} className="integrationImages"/>
                    </Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">HTTP</Card.Subtitle>
                    <Card.Text>
                        The HTTP integration forwards events to a user-configurable endpoint as POST requests.
                    </Card.Text>
                    {props.options.integrations == true ? (
                        <>
                            {!!props.add && <Card.Link href={`#/lora/applications/${props.applicationID}/http/create`}>Add</Card.Link>}
                            {!!props.edit && 
                                <>
                                    <Card.Link href={`#/lora/applications/${props.applicationID}/http/edit`}>Edit</Card.Link>
                                    <Card.Link href="#" onClick={(e)=>deleteHTTP(e)}>Delete</Card.Link>
                                </>
                            }
                        </>
                    ) : null}

                </Card.Body>
            </Card>
        </Col>

    )
}

export default HTTPCard
